import { FacturasTable, FACTURA_TABLE_SCOPE } from '../../cobros/components/FacturasTable';
import { ClienteCoberturaPrepagoBanner } from './ClienteCoberturaPrepagoBanner';

interface ClienteFacturasListProps {
  clienteId: number;
}

export function ClienteFacturasList({ clienteId }: ClienteFacturasListProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <ClienteCoberturaPrepagoBanner clienteId={clienteId} />
      <FacturasTable scope={FACTURA_TABLE_SCOPE.CLIENTE} clienteId={clienteId} />
    </div>
  );
}
